<template lang="html">
    <div class="common-select common-select-search">
        <input type="hidden" v-bind:value="innerValue" />
        <div class="common-select-title"><span @click="handleSelectClick">{{title}}</span><common-tooltip v-if="!!tipCode" :tipCode="tipCode"></common-tooltip><span class="not-required" :class="required?'required':''">*</span></div>
        <div :class="['common-select-infos',alignRight?'common-select-infos-align-right':'']" @click="handleSelectClick">
            <div class="common-select-text">{{currentText}}</div>
            <div class="common-select-placeholder" v-show="!currentText">{{placeholder}}</div>
            <div :class="'common-select-dropdown-icon-'+iconType"></div>
        </div>
        <mt-popup
            v-model="popupVisible"
            position="bottom"
            class="common-select-options">
            <div class="common-select-options-toolbar">
                <mt-button v-if="clearable && innerValue" @click="handleCancleClick" type="default" size="small" class="common-select-options-toolbar-cancel-btn cancel-btn">清除</mt-button>
                <input class="search-input" type="search" :placeholder="'请输入'+title" v-model="inputText" />
                <mt-button @click="handleComfirmClick" type="primary" size="small" class="common-select-options-toolbar-confirm-btn">确定</mt-button>
            </div>
            <mt-picker ref="picker" :slots="slots" @change="handleValuesChange" showToolbar :value-key="textKey">
                
            </mt-picker>
        </mt-popup>
    </div>
</template>

<script>
import { Popup, Picker } from 'mint-ui';
  export default {
    props: {
        'title': {
            type: String,
            required: false
        },
        'placeholder': {
            type: String,
            required: false
        },
        'datas': {
            required: true
        },
        'valueKey': {
            type:String,
            required: true
        },
        'textKey': {
            type:String,
            required: true
        },
        'alignRight': {
            type:Boolean,
            required: false,
            default:false,
        },
        'value': {

        },
        'clearable': {
            type:Boolean,
            required: false,
            default:false,
        },
        'remoteMethod': {
            type: Function,
            required: true
        },
        'required': {
            type:Boolean,
            required: false,
            default: false,
        },
        'tipCode': {
            required: false
        },
        'iconType': {
            type: String,
            required: false,
            default:'arrow'
        }
    },
    event: 'change',
    components: {
        Popup,
        Picker,
    },
    data() {
        return {
            popupVisible: false,
            slots: [
                {            
                    values: [],
                    defaultIndex: 0
                },
            ],
            selectObj: null,
            inputText: ''
        };
    },
    computed: {
        currentText() {
            if(!this.value || !this.datas){
                return '';
            }

            let text = '';
            this.datas.forEach(element => {
                if(element[this.valueKey] == this.value){
                    text = element[this.textKey];
                }
            });

            return text;
        },
        innerValue: {
            get() {
               return this.value 
            },
            set(val) {
                 this.$emit('input', val) //这里多用于子组件间没有input元素中,通过在computed属性中监听值变化事emit input事件
            }
        }
    },
    methods: {
        handleSelectClick() {
            this.popupVisible = true;
        },
        handleValuesChange(picker, values) {
            this.selectObj = values[0];
        },
        handleCancleClick() {
            this.innerValue = '';
            this.selectObj = this.datas[0];
            this.$refs.picker.setValues([this.selectObj])
            
            this.popupVisible = false;

            this.$emit('change');
        },
        handleComfirmClick() {
            if(this.selectObj && this.selectObj[this.valueKey].toString() != this.value) {
                if(this.selectObj) {
                    this.innerValue = this.selectObj[this.valueKey].toString();
                }
                this.popupVisible = false;

                this.$emit('change');
            }
            else{
                this.popupVisible = false;
            }
        },
        initSlotData() {
            if(this.datas){
                for (let index = 0; index < this.datas.length; index++) {
                    const element = this.datas[index];
                    if(element[this.valueKey] == this.value) {
                        this.slots[0].defaultIndex = index;
                    }
                }
            }

            this.slots[0].values = this.datas;
        }
    },
    watch: {
        datas() {
            this.initSlotData();
        },
        value() {
            this.innerValue = this.value;
            if(this.datas){
                this.selectObj = this.datas[0];
                
                for (let index = 0; index < this.datas.length; index++) {
                    const element = this.datas[index];
                    if(element[this.valueKey] == this.value) {
                        this.selectObj = element;
                    }
                }
            
                this.$refs.picker.setValues([this.selectObj])
            }
        },
        inputText() {
            if(this.remoteMethod) {
                this.remoteMethod(this.inputText);
            }
        }
    },
    mounted: function() {
        this.initSlotData()
    }
  };
</script>

<style lang="less" scoped>
    .common-select {
        display: flex;
        min-height: 24px;
        font-size: 14px;

        &-title {
            line-height: 24px;
        }

        &-dropdown-icon-trigle {
            width: 0;
            height: 0;
            border-left: 6px solid transparent; //左边宽度50px，实线，透明颜色
            border-right: 6px solid transparent; //右边同上
            border-top: 6px solid #999999;
            margin-top: 9px;
            margin-left: 7px;
        }

        &-dropdown-icon-arrow {
            width: 9px;
            height: 9px;
            margin-top: 7px;
            border-top: 1px solid #999999;
            border-right: 1px solid #999999;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            margin-left: 4px;
        }

        &-text {
            min-height: 24px;
            line-height: 24px;
            max-width: 200px;
        }

        &-infos {
            display: flex;

            &-align-right {
                    margin-left: auto;
                    padding-right: 20px;
            }
        }

        &-placeholder {
            color: #999999;
            line-height: 24px;
        }

        &-options {
            &-toolbar {
                padding: 5px 15px 0 15px;

                &-cancel-btn {
                    float: left;
                }

                &-confirm-btn {
                    float: right;
                }

                .search-input {
                    height: 35px;
                    width: 220px;
                    position: absolute;
                    right: 80px;
                    border: 1px solid #dfdfdf;
                    padding: 0 10px;
                    border-radius: 4px;
                }
            }
        }      

        .not-required {
            display: none;
        }
        
        .required {
            display: inline;
            color: #E64100;
            margin-left: 5px;
        }
    }
</style>


// WEBPACK FOOTER //
// CommonSelectSearch.vue?47d6669a